export const UPDATE_LOGINED_ACTION_TYPE = 'UPDATE_LOGINED_ACTION_TYPE' as const;
